import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Box,
  Spinner,
  Progress,
  Badge,
  Flex,
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
} from '@chakra-ui/react'
import { useRoleta } from '../hooks/RoletaContext'

export const ModalSumarioPremios = ({ isOpen, onClose }) => {
  const { premios, isLoading, error } = useRoleta()

  const totalDistribuido = premios.reduce((acc, premio) => acc + premio.vezes_dia, 0)
  const totalRestante = premios.reduce((acc, premio) => acc + premio.qtd_dia, 0)
  const totalGeral = totalDistribuido + totalRestante

  if (isLoading) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Sumário de Brindes</ModalHeader>
          <ModalCloseButton />
          <ModalBody textAlign="center" py={10}>
            <Spinner size="xl" color="blue.500" />
            <Text mt={4}>Carregando sumário de brindes...</Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Sumário de Brindes</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <StatGroup mb={6}>
            <Stat>
              <StatLabel>Total Distribuído</StatLabel>
              <StatNumber>{totalDistribuido}</StatNumber>
              <StatHelpText>{totalGeral > 0 ? ((totalDistribuido / totalGeral) * 100).toFixed(1) : 0}%</StatHelpText>
            </Stat>
            <Stat>
              <StatLabel>Total Restante</StatLabel>
              <StatNumber>{totalRestante}</StatNumber>
              <StatHelpText>{totalGeral > 0 ? ((totalRestante / totalGeral) * 100).toFixed(1) : 0}%</StatHelpText>
            </Stat>
            <Stat>
              <StatLabel>Total Geral</StatLabel>
              <StatNumber>{totalGeral}</StatNumber>
            </Stat>
          </StatGroup>

          {error ? (
            <Box textAlign="center" py={4}>
              <Text color="red.500">Erro ao carregar o sumário. Por favor, tente novamente.</Text>
            </Box>
          ) : (
            <Table variant="simple" size="sm">
              <Thead>
                <Tr>
                  <Th>Nome do Prêmio</Th>
                  <Th>Distribuídos</Th>
                  <Th>Restantes</Th>
                  <Th>Progresso</Th>
                </Tr>
              </Thead>
              <Tbody>
                {premios.map((premio) => (
                  <Tr key={premio.id}>
                    <Td>{premio.nome_premio}</Td>
                    <Td>{premio.vezes_dia}</Td>
                    <Td>{premio.qtd_dia}</Td>
                    <Td width="30%">
                      <Flex align="center" gap={2}>
                        <Progress
                          value={premio.qtd_dia > 0 ? (premio.vezes_dia / premio.qtd_dia) * 100 : 0}
                          size="sm"
                          colorScheme="blue"
                          width="100%"
                          borderRadius="md"
                        />
                        <Badge>{premio.qtd_dia > 0 ? ((premio.vezes_dia / premio.qtd_dia) * 100).toFixed(0) : 0}%</Badge>
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
